export default class SelectedAddressDetails {
  streetAddress: string;
  city: string;
  provinceCode: string;
  postalCode: string;
  latitude: string;
  longitude: string;
  timeZone: string;

  constructor(
    streetAddress: string,
    city: string,
    provinceCode: string,
    postalCode: string,
    latitude: string,
    longitude: string,
    timeZone: string,
  ) {
    this.streetAddress = streetAddress;
    this.city = city;
    this.provinceCode = provinceCode;
    this.postalCode = postalCode;
    this.latitude = latitude;
    this.longitude = longitude;
    this.timeZone = timeZone;
  }
}
